// extracted by mini-css-extract-plugin
export default {"content":"button-with-loader_content__kfq30","spinner":"button-with-loader_spinner__McYkO"};